"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1092],{

/***/ 98992:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ useModal; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _context_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40062);



function useModal() {
  const context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_context_es_js__WEBPACK_IMPORTED_MODULE_1__/* .ModalStateContext */ .s);
  if (!context) {
    throw new Error("useModal must be inside a ModalStateContext with a state value");
  }
  return context;
}




/***/ }),

/***/ 90450:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ PreLoad; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55271);
/* harmony import */ var _Loading_LogoLoading_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6901);




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  position: relative;
  border-radius: 0.5rem;
  background: #fff;
  height: ${(props) => props.height + "px"};
  user-select: none;
`;
const StyledLogoLoading = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_Loading_LogoLoading_es_js__WEBPACK_IMPORTED_MODULE_2__/* .LogoLoading */ .h)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
`;
const PreLoad = (_a) => {
  var _b = _a, {
    height,
    isLoading,
    hideLogo = false,
    logo
  } = _b, props = __objRest(_b, [
    "height",
    "isLoading",
    "hideLogo",
    "logo"
  ]);
  if (!isLoading)
    return null;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadProps(__spreadValues({}, props), {
    height
  }), !hideLogo && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledLogoLoading, {
    logo
  }));
};




/***/ }),

/***/ 41092:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ ForceLogin; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20348);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89703);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(53769);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(55271);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63438);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _teko_auth_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(18678);
/* harmony import */ var _components_Loading__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(28858);
/* harmony import */ var _terra_js_web_bridge__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85172);
/* harmony import */ var _terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47360);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(98992);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(71323);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(48441);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(31260);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89053);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _teko_user__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(20483);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(55140);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(86324);
/* harmony import */ var _teko_log__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20577);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  height: 100vh;\n  background: white;\n  align-items: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  width: 80px;\n  height: 80px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}















// this sucks
// ideally, we should never have to import both mobile and desktop component
// should use router.push instead. Let routing handle that.
const UpdateProfileDesktop = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(()=>Promise.all(/* import() */[__webpack_require__.e(1316), __webpack_require__.e(3667), __webpack_require__.e(6123)]).then(__webpack_require__.bind(__webpack_require__, 26123)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(26123)
            ]
    }
});
const UpdateProfileMobile = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(()=>Promise.all(/* import() */[__webpack_require__.e(3667), __webpack_require__.e(5836)]).then(__webpack_require__.bind(__webpack_require__, 85836)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(85836)
            ]
    }
});
// this component should be phased out
const UpdateInfoForm = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(()=>__webpack_require__.e(/* import() */ 7611).then(__webpack_require__.bind(__webpack_require__, 17611)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(17611)
            ]
    }
});
const Wrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_7__/* .styled.div */ .z.div(_templateObject());
const LoaderWrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_7__/* .styled.div */ .z.div(_templateObject1());
const BYPASS_LOGIN_PATHS = /^.*(\/content\/\[id\])|(\/p\/\[slug\])$/;
const useConfirmDealerAssignment = (refCode)=>{
    const { identityRequired  } = (0,contexts__WEBPACK_IMPORTED_MODULE_8__/* .useTenantConfig */ .Wx)();
    const { user  } = (0,_teko_auth_react__WEBPACK_IMPORTED_MODULE_9__/* .useAuth */ .a)();
    const { showModal  } = (0,_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_10__/* .useModal */ .d)();
    const { userService  } = (0,contexts__WEBPACK_IMPORTED_MODULE_11__/* .useServices */ .Su)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const onCancelPopup = ()=>{
        var ref;
        sessionStorage.removeItem("ref_code");
        if (!(user === null || user === void 0 ? void 0 : (ref = user.dealer) === null || ref === void 0 ? void 0 : ref.id) && identityRequired === "dealer-required") {
            // if require dealer, signout
            (window).TekoID.user.logout();
        } else {
            setLoading(false);
            router.replace("/", undefined, {
                shallow: true
            });
        }
    };
    const popup = (param)=>{
        let { title , message , onOk , okText , onCancel , cancelText  } = param;
        showModal({
            title: title || (0,i18n__WEBPACK_IMPORTED_MODULE_12__.t)("Th\xf4ng b\xe1o"),
            okText: okText || (0,i18n__WEBPACK_IMPORTED_MODULE_12__.t)("Đ\xf3ng"),
            cancelText: cancelText || "",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_13__/* .Body */ .uT, {
                children: message
            }),
            onOk: onOk || onCancelPopup,
            onCancel: onCancel || onCancelPopup,
            closable: false,
            fullWidthFooter: true
        });
    };
    const { 0: loading , 1: setLoading  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(!!refCode);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (refCode && user) {
            const handleConfirmError = (err)=>{
                var ref;
                sessionStorage.removeItem("ref_code");
                _teko_log__WEBPACK_IMPORTED_MODULE_6__/* .logger.error */ .k.error(err);
                popup({
                    message: (err === null || err === void 0 ? void 0 : err.message) || (err === null || err === void 0 ? void 0 : (ref = err.response) === null || ref === void 0 ? void 0 : ref.message)
                });
            };
            const onAssignDealerSuccess = ()=>{
                sessionStorage.removeItem("ref_code");
                popup({
                    message: (0,i18n__WEBPACK_IMPORTED_MODULE_12__.t)("Đăng k\xfd t\xe0i khoản th\xe0nh c\xf4ng"),
                    title: (0,i18n__WEBPACK_IMPORTED_MODULE_12__.t)("Th\xf4ng b\xe1o"),
                    okText: (0,i18n__WEBPACK_IMPORTED_MODULE_12__.t)("Đ\xf3ng"),
                    onOk: ()=>{
                        router.replace("/");
                        setLoading(false);
                    }
                });
            };
            (async ()=>{
                try {
                    const refCodeInfo = await userService.getRefCodeInfo(refCode);
                    const { dealer  } = refCodeInfo.data || {};
                    if (!dealer) {
                        // if there is no dealer,
                        throw new Error("Invalid refCode " + refCode);
                    }
                    if (user.dealer) {
                        if (user.dealer.id === dealer.id) {
                            // dealer is already assigned,
                            // there is nothing to do
                            onCancelPopup();
                            return;
                        }
                        // else confirm if user are ok with the change
                        const msg = (0,_teko_utils__WEBPACK_IMPORTED_MODULE_14__/* .customizedMessage */ .$e)((0,i18n__WEBPACK_IMPORTED_MODULE_12__.t)("_template.desktop._module.components.IdentityRequired.1"), [
                            {
                                name: "oldDealer",
                                value: user.dealer.name || user.dealer.telephone
                            },
                            {
                                name: "newDealer",
                                value: dealer.name || dealer.telephone
                            }, 
                        ]);
                        popup({
                            message: msg,
                            title: (0,i18n__WEBPACK_IMPORTED_MODULE_12__.t)("X\xe1c nhận đổi đại l\xfd"),
                            okText: (0,i18n__WEBPACK_IMPORTED_MODULE_12__.t)("Đồng \xfd"),
                            cancelText: (0,i18n__WEBPACK_IMPORTED_MODULE_12__.t)("Hủy"),
                            onOk: async ()=>{
                                try {
                                    await userService.confirmFarmer(refCode);
                                    onAssignDealerSuccess();
                                } catch (er) {
                                    handleConfirmError(er);
                                }
                            },
                            onCancel: onCancelPopup
                        });
                    } else {
                        await userService.confirmFarmer(refCode);
                        onAssignDealerSuccess();
                    }
                } catch (er) {
                    _teko_log__WEBPACK_IMPORTED_MODULE_6__/* .logger.error */ .k.error("Confirm farmer error code", er);
                    popup({
                        message: (0,_teko_utils__WEBPACK_IMPORTED_MODULE_14__/* .customizedMessage */ .$e)((0,i18n__WEBPACK_IMPORTED_MODULE_12__.t)("M\xe3 giới thiệu {refCode} kh\xf4ng hợp lệ"), [
                            {
                                name: "refCode",
                                value: refCode
                            }
                        ])
                    });
                    sessionStorage.removeItem("ref_code");
                }
            })();
        }
    }, [
        refCode,
        user
    ]);
    return {
        loading
    };
};
const ForceLogin = (param)=>{
    let { children  } = param;
    var ref;
    const { isMobile , identityRequired , supportedPhone: hotline , requireLogin , requiresUserOverEighteenYearsOld ,  } = (0,contexts__WEBPACK_IMPORTED_MODULE_8__/* .useTenantConfig */ .Wx)();
    const { user , loading , authService , loginWithPartner  } = (0,_teko_auth_react__WEBPACK_IMPORTED_MODULE_9__/* .useAuth */ .a)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const isBypassed = BYPASS_LOGIN_PATHS.test(router.route) || router.asPath.includes("/login");
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!loading && !(user === null || user === void 0 ? void 0 : user.userId) && !isBypassed) {
            if (!_terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isAvailable */ .Z.isAvailable()) authService.login();
            else {
                const partnerLogin = async ()=>{
                    const [accessToken, userInfo] = await Promise.all([
                        _terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_4__/* ["default"].auth */ .Z.auth().getAccessTokenAsync(),
                        _terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_4__/* ["default"].auth */ .Z.auth().getFullUserInfo(), 
                    ]);
                    loginWithPartner({
                        partnerType: "consumerapp",
                        userInfo: {
                            userId: userInfo.sub,
                            name: userInfo.name,
                            accessToken,
                            phone: userInfo.phoneNumber,
                            picture: userInfo.picture,
                            email: userInfo.email
                        }
                    }, false, false);
                };
                partnerLogin();
            }
        }
    }, [
        loading,
        user === null || user === void 0 ? void 0 : user.userId
    ]);
    // CP case:
    // todo: move this logic somewhere else. preferrably its own route
    const identityRefCode =  true ? window.sessionStorage.getItem("ref_code") : 0;
    const { loading: checkingDealer  } = useConfirmDealerAssignment(identityRefCode);
    if (!isBypassed && (loading || !user || checkingDealer)) {
        // iam is not initialized
        // return a loading screen
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Wrapper, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LoaderWrapper, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Loading__WEBPACK_IMPORTED_MODULE_15__/* .PreLoad */ .b7, {
                    height: 40,
                    isLoading: true
                })
            })
        });
    }
    if (isBypassed) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: children
        });
    }
    // after user login, there are some additional logic
    // like verifying if users have their profiles updated
    const isAccountActive = (user === null || user === void 0 ? void 0 : user.approvalStatus) === _teko_user__WEBPACK_IMPORTED_MODULE_16__/* .ApprovalStatus.APPROVED */ .K.APPROVED && !!(user === null || user === void 0 ? void 0 : user.isActive);
    if (!isAccountActive) {
        return isMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UpdateProfileMobile, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UpdateProfileDesktop, {});
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            children,
            !(user === null || user === void 0 ? void 0 : (ref = user.dealer) === null || ref === void 0 ? void 0 : ref.id) && identityRequired === "dealer-required" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_17__/* .Modal */ .u, {
                visible: true,
                closable: false,
                title: (0,i18n__WEBPACK_IMPORTED_MODULE_12__.t)("Th\xf4ng b\xe1o"),
                okText: "",
                onCancel: ()=>{
                    if (requireLogin) {
                        // force logging out in case login is required in the whole site
                        (window).TekoID.user.logout();
                    } else {
                        // back to previous page when there's one page surrounded by ForceLogin
                        router.back();
                    }
                },
                cancelText: requireLogin ? (0,i18n__WEBPACK_IMPORTED_MODULE_12__.t)("Đăng xuất") : (0,i18n__WEBPACK_IMPORTED_MODULE_12__.t)("Đ\xf3ng"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_13__/* .Body */ .uT, {
                    children: (0,_teko_utils__WEBPACK_IMPORTED_MODULE_14__/* .customizedMessage */ .$e)((0,i18n__WEBPACK_IMPORTED_MODULE_12__.t)("_template.desktop._module.components.IdentityRequired.0"), [
                        {
                            name: "hotline",
                            value: hotline
                        }
                    ])
                })
            }),
            requiresUserOverEighteenYearsOld && (!(user === null || user === void 0 ? void 0 : user.dob) || !(user === null || user === void 0 ? void 0 : user.sex) || !(user === null || user === void 0 ? void 0 : user.name)) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UpdateInfoForm, {})
        ]
    });
};


/***/ }),

/***/ 28858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "GN": function() { return /* binding */ ContainerLoading; },
  "gb": function() { return /* binding */ Loading; },
  "b7": function() { return /* binding */ PreLoad; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-17.0.2-99ba37d931-b254cc17ce.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(20348);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-17.0.2-99ba37d931-b254cc17ce.zip/node_modules/react/index.js
var react = __webpack_require__(89703);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/libs/styled.es.js
var styled_es = __webpack_require__(55271);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-bb101883bc/1/packages/ecommerce/dist/Common/PreLoad/PreLoad.es.js
var PreLoad_es = __webpack_require__(90450);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(55140);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/LazyImage/LazyImage.es.js
var LazyImage_es = __webpack_require__(79185);
;// CONCATENATED MODULE: ./components/LogoLoading.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  width: 80px;\n  height: 80px;\n  position: relative;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



const Wrapper = styled_es/* styled.div */.z.div(_templateObject());
const Logo = (0,styled_es/* styled */.z)(LazyImage_es/* LazyImage */.w)(_templateObject1());
const Spinner = styled_es/* styled.div */.z.div((param)=>{
    let { theme  } = param;
    return "\n    background: none;\n    @keyframes ldio-yuapljtmof {\n      0% {\n        transform: rotate(0deg);\n      }\n      50% {\n        transform: rotate(180deg);\n      }\n      100% {\n        transform: rotate(360deg);\n      }\n    }\n    .ldio-yuapljtmof  {\n      position: absolute;\n      top: 0;\n      right: 0;\n      left: 0;\n      bottom: 0;\n      margin: auto;\n      animation: ldio-yuapljtmof 1s linear infinite;\n      width: 70px;\n      height: 70px;\n      border-radius: 50%;\n      box-shadow: 0 2px 0 0 ".concat(theme.brand.loading || "#1435c3", ";\n      box-sizing: content-box;\n    }\n");
});
const LogoLoading = (_param)=>{
    var { logo =""  } = _param, props = _objectWithoutProperties(_param, [
        "logo"
    ]);
    const size = 80;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, _objectSpreadProps(_objectSpread({}, props), {
        children: [
            logo && /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo, {
                width: size / 2,
                height: size / 2,
                src: logo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "ldio-yuapljtmof"
                })
            })
        ]
    }));
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Loading/Loading.es.js
var Loading_es = __webpack_require__(12433);
;// CONCATENATED MODULE: ./components/Loading.tsx
function Loading_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Loading_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Loading_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Loading_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function Loading_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        Loading_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function Loading_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = Loading_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Loading_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Loading_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Loading_templateObject() {
    const data = Loading_taggedTemplateLiteral([
        "\n  position: relative;\n"
    ]);
    Loading_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Loading_templateObject1() {
    const data = Loading_taggedTemplateLiteral([
        "\n  position: relative;\n  transition: opacity 0.3s;\n  &.loading-blur {\n    clear: both;\n    overflow: hidden;\n    opacity: 0.5;\n    user-select: none;\n    pointer-events: none;\n  }\n"
    ]);
    Loading_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = Loading_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1000;\n  width: 100%;\n  height: 100%;\n  max-height: 400px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







const Loading = (param)=>{
    let { isLoading , children  } = param;
    const { logo  } = (0,GlobalDataContext/* useGlobalData */.U5)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading_es/* Loading */.g, {
        isLoading: isLoading,
        logo: (logo.loading || logo.lite).path,
        children: children
    });
};
const PreLoad = (_param)=>{
    var { isLoading  } = _param, props = Loading_objectWithoutProperties(_param, [
        "isLoading"
    ]);
    var ref;
    const { logo  } = (0,GlobalDataContext/* useGlobalData */.U5)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PreLoad_es/* PreLoad */.b, Loading_objectSpreadProps(Loading_objectSpread({}, props), {
        isLoading: isLoading,
        logo: (ref = logo.loading || logo.lite) === null || ref === void 0 ? void 0 : ref.path
    }));
};
const ContainerLoadingWrapper = styled_es/* styled.div */.z.div(Loading_templateObject());
const Container = styled_es/* styled.div */.z.div(Loading_templateObject1());
const LoadingContainer = styled_es/* styled.div */.z.div(_templateObject2());
const ContainerLoading = (param)=>{
    let { children , style , isLoading =true  } = param;
    var ref;
    const { logo  } = (0,GlobalDataContext/* useGlobalData */.U5)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContainerLoadingWrapper, {
        children: [
            isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingContainer, {
                style: style,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoLoading, {
                    logo: (ref = logo.loading || logo.lite) === null || ref === void 0 ? void 0 : ref.path
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
                className: isLoading ? "loading-blur" : "",
                children: children
            })
        ]
    });
};


/***/ }),

/***/ 20483:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ ApprovalStatus; }
/* harmony export */ });
var ApprovalStatus = /* @__PURE__ */ ((ApprovalStatus2) => {
  ApprovalStatus2["APPROVED"] = "approved";
  ApprovalStatus2["REJECTED"] = "rejected";
  ApprovalStatus2["NEW"] = "new";
  ApprovalStatus2["REQUEST_APPROVAL"] = "request_approval";
  return ApprovalStatus2;
})(ApprovalStatus || {});




/***/ })

}]);